import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ResourceLoadTable.html?raw';
import { VAM2types, VAMclassNames } from "../../_loadingHelpers/VAMv2Types";
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import GenericEntityView from '../../../moreCore/UI/EntityBased/EntityView/GenericEntityView';


class EvService_ResourceLoadTable extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private tableContainer: HTMLElement;
    private overloadWarning: HTMLElement;
    private _data: Array<VAM2types.ResourceLoadData>;
    private _sourceBooking: VAM2types.EvBooking_Base;
    private _sourceServiceBooking: VAM2types.EvServiceBooking;
    private _isOverload: boolean = null;

    private _tableLayout: StaticTable.Layout = {
        rows: [{
            widths: [null, "15ch", "15ch"],
            attributes: ["description", "amountNeeded", "load"],
            headings: ["General_Label_Resource", "PhysicalResource_Label_QuantityNeeded", "PhysicalResource_Label_QuantityLoad"],

        }],
        name: "default",
        label: "default",
        layoutStyle: "auto"
    };

    // setup(data: Array<VAM2types.ResourceBooking>, isVirtual?: boolean) {
    setData(data: Array<VAM2types.ResourceLoadData>, sourceServiceBooking: VAM2types.EvServiceBooking, sourceBooking: VAM2types.EvBooking_Base) {

        this._data = data;
        this._sourceBooking = sourceBooking;
        this._sourceServiceBooking = sourceServiceBooking;

        this.checkOverload();


        let table = new StaticTable();
        table.placeAt(this.tableContainer, "only");
        //table.setLabel("General_Label_Resources");
        table.setLayout(this._tableLayout);

        table.setFormatter(lang.hitch(this, this.resourcesTable_formatterFunction));
        //innerTable.addDefaultRowActionButton("sync", lang.hitch(this, this._onClick_SyncResource));
        if (this._sourceBooking) {
            table.addCustomRowActionButtonEx({
                name: "showOverlap",
                callback: lang.hitch(this, this._showOverlap),
                iconClass: "fas fa-stream",
                enable: lang.hitch(this, this._enableShowOverlap),
                position: 120,
                hideIfDisabled: true,
                tooltipTitle: "PhysicalResource_Label_ShowOverlappingBookings"});
        }

        table.setData(data);
        table.setCyAttribute("resourceLoadTable");
    }
    private checkOverload() {
        this._isOverload = null;
        this.isOverloaded();
    }
    isOverloaded(targetResourceID?: string): boolean {
        if (this._isOverload != null) return this._isOverload;

        if( !targetResourceID ) this.hideNode(this.overloadWarning);

        if (!this._data?.length) return false;

        for (let entry of this._data) {
            if (entry.resourceID == targetResourceID || !targetResourceID) {
                if (entry.amountWarning2 && entry.load >= entry.amountWarning2) {
                    this.hideNode(this.overloadWarning, false);
                    return true;
                }
            }
        }
        return false;
    }

    private resourcesTable_formatterFunction(cell: StaticTable.StaticTableCell<VAM2types.ResourceLoadData>) {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;
        let rowIndex = cell.tableRow.rowGroup.rowIndex;

        //this.UiModder.domClass.toggle(node, "w3-text-red", !entity.ref_performer);

        switch (colName) {
            case "load":

                this.UiModder.domClass.toggle(cell.tableCellNode, "warningRed", entity.isWarningLevel2);
                this.UiModder.domClass.toggle(cell.tableCellNode, "warningYellow", entity.isWarningLevel1);
                
                cell.value += "/" + entity.amountStock;
                node.innerHTML = cell.value;

                return true;
                break;

            //case "quantity":
            case "amountNeeded":

                this.UiModder.domClass.toggle(cell.tableCellNode, "warningRed", entity.isWarningLevel2);
                this.UiModder.domClass.toggle(cell.tableCellNode, "warningYellow", entity.isWarningLevel1);


                let valueStr = entity.amountNeeded.toString();

                let suffix = "";

                // 50 x 1 ist ok. 1 x 50 nicht anzeigen.
                if (1 != entity.serviceMultiplier) {
                    suffix = entity.serviceMultiplier + " × " + entity.amountPerService;
                } else if (entity.amountPerService != 1 && entity.amountNeeded != entity.amountPerService) {
                    suffix = entity.amountPerService.toString();
                }

                if (suffix.length) suffix = " (" + suffix + ")";


                node.innerHTML = valueStr + suffix;

                return true;
                break;
        }

        return false;
    }

    private _enableShowOverlap(entity: VAM2types.ResourceLoadData, grp: StaticTable.StaticTableRowGroup<VAM2types.ResourceLoadData>): boolean {
        if (entity.isWarningLevel1 || entity.isWarningLevel2) return true;
        return false;
    }
    private _showOverlap(grp: StaticTable.StaticTableRowGroup<VAM2types.ResourceLoadData>) {
        debugger;
        let data = {
            dateStart: this._sourceBooking.date_start,
            dateEnd: this._sourceBooking.date_end,
            evBookingID: this._sourceBooking.ID,
            resourceID: grp.entity.resourceID,
            resourceBookingID: grp.entity.resourceBookingID,
            resourceMultiplier: grp.entity.amountPerService,
            serviceID: this._sourceServiceBooking.serviceID,
            serviceBookingID: this._sourceServiceBooking.ID
        }

        let genericView = new GenericEntityView();
        genericView.setup(grp.entity.resourceID,
            "physical_resources", //VAMclassNames.physical_resource,
            grp.displayname,
            "description",
            "dlg",
            data,
            "overlappings");
    }


    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvService_ResourceLoadTable);